(function(){
  const KEY_SIGNED_UP = 'lv_popup_signed_up';
  const KEY_SESSION_SHOWN = 'lv_popup_session_shown';
  const KEY_SEEN = 'lv_popup_seen_until';

  const el = document.getElementById('lv-popup');
  if(!el) return;

  const tab = el.querySelector('[data-lv-tab]');
  const step1 = el.querySelector('.lv-step--1');
  const step2 = el.querySelector('.lv-step--2');
  const step3 = el.querySelector('.lv-step--3');
  const smsWrap = el.querySelector('#lv-sms-wrap');
  const tierField = el.querySelector('#lv-tier');
  const codeEl = el.querySelector('#lv-code');

  let showingConfirmation = false;
  let allowClose = true;
  let isExpanded = false;

  function showTab(){
    el.classList.remove('hidden');
    sessionStorage.setItem(KEY_SESSION_SHOWN, 'true');
  }

  function expand(){
    if(isExpanded) return;
    isExpanded = true;
    el.classList.add('expanded');
    document.body.style.overflow='hidden';
  }

  function collapse(){
    if(showingConfirmation || !allowClose){
      console.log('[LV Popup] Blocked collapse - showing confirmation');
      return;
    }
    isExpanded = false;
    el.classList.remove('expanded');
    document.body.style.overflow='';
  }

  function hide(){
    if(showingConfirmation || !allowClose){
      console.log('[LV Popup] Blocked hide - showing confirmation');
      return;
    }
    el.classList.add('hidden');
    el.classList.remove('expanded');
    document.body.style.overflow='';
    isExpanded = false;
    const until = Date.now() + 7*24*60*60*1000;
    localStorage.setItem(KEY_SEEN, String(until));
    sessionStorage.setItem(KEY_SESSION_SHOWN, 'true');
  }

  function moveTo(a,b,c){ step1.classList.toggle('hidden', !a); step2.classList.toggle('hidden', !b); step3.classList.toggle('hidden', !c); }

  // NEVER show again if user has signed up
  if(localStorage.getItem(KEY_SIGNED_UP) === 'true') return;

  // Show once per session only
  if(sessionStorage.getItem(KEY_SESSION_SHOWN) === 'true') return;

  // Check 7-day suppression for users who closed without signing up
  const seenUntil = Number(localStorage.getItem(KEY_SEEN) || 0);
  if(seenUntil > Date.now()) return;

  // Check popup coordinator - only show if newsletter is allowed
  if(window.LVPopupCoordinator) {
    const allowedPopup = window.LVPopupCoordinator.determineAllowedPopup();
    if(allowedPopup !== 'newsletter') return;
  }

  let fired = false;
  const isMobile = window.matchMedia('(max-width: 749px)').matches;
  const tryShow = () => {
    if(!fired){
      fired = true;
      if(window.LVPopupCoordinator) {
        window.LVPopupCoordinator.markNewsletterSeen();
        window.LVPopupCoordinator.markSessionPopupShown();
      }
      showTab();
      document.dispatchEvent(new CustomEvent('lv:newsletter-shown'));
    }
  };

  // Delay popup so it does not hit mobile visitors the moment they land.
  const showDelay = isMobile ? 12000 : 5000;
  setTimeout(tryShow, showDelay);

  if(tab){
    tab.addEventListener('click', () => {
      expand();
    });
  }

  document.addEventListener('keydown', (e) => {
    if(e.key === 'Escape'){
      if(showingConfirmation && !allowClose){
        e.preventDefault();
        e.stopPropagation();
        console.log('[LV Popup] Blocked ESC - confirmation visible');
      } else if(isExpanded){
        collapse();
      }
    }
  }, true);

  const backdrop = el.querySelector('.lv-popup__backdrop');
  if(backdrop){
    backdrop.addEventListener('click', (e) => {
      if(showingConfirmation || !allowClose){
        e.preventDefault();
        e.stopPropagation();
        console.log('[LV Popup] Blocked backdrop click - confirmation visible');
        return false;
      } else {
        collapse();
      }
    }, true);
  }

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if(mutation.type === 'attributes' && mutation.attributeName === 'class'){
        if((showingConfirmation || !allowClose) && el.classList.contains('hidden')){
          console.warn('[LV Popup] BLOCKED external hide - restoring');
          el.classList.remove('hidden');
          el.classList.add('expanded');
          document.body.style.overflow = 'hidden';
        }
      }
    });
  });

  observer.observe(el, {
    attributes: true,
    attributeFilter: ['class']
  });

  el.querySelectorAll('[data-lv-close]').forEach(b => b.addEventListener('click', () => {
    if(showingConfirmation){
      console.log('[LV Popup] User closed confirmation');
      showingConfirmation = false;
      allowClose = true;
    }
    hide();
  }));

  el.querySelectorAll('[data-lv-tier]').forEach(btn => {
    btn.addEventListener('click', () => {
      const tier = btn.getAttribute('data-lv-tier');
      if(tier === 'none'){ hide(); return; }
      tierField.value = tier;
      smsWrap.classList.toggle('hidden', tier !== 'sms');
      moveTo(false,true,false);
    });
  });

  const form = document.getElementById('lv-signup-form');
  if(form){
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      e.stopPropagation();

      const tier = tierField.value || 'email';
      const code = (tier === 'sms') ? 'WELCOME20LV' : 'WELCOME15LV';
      codeEl.textContent = code;

      // LOCK popup open - prevent any auto-close
      showingConfirmation = true;
      allowClose = false;
      console.log('[LV Popup] Showing confirmation - popup locked open');

      moveTo(false,false,true);

      try {
        const url = new URL(window.location.href);
        url.searchParams.set('discount', code);
        window.history.replaceState({}, '', url.toString());
      } catch(_) {}

      try {
        const data = new FormData(form);
        await fetch(form.action, { method:'POST', body:data, credentials:'same-origin' });
      } catch(_) {}

      // Mark as signed up permanently - NEVER show again
      localStorage.setItem(KEY_SIGNED_UP, 'true');
      sessionStorage.setItem(KEY_SESSION_SHOWN, 'true');

      // Confirmation page stays open until user closes it manually
      console.log('[LV Popup] Confirmation displayed - waiting for user to close');
    });
  }
})();
